import { CommonModule, NgIf } from '@angular/common';
import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-table-tasks-latest-comment-renderer',
  standalone: true,
  imports: [CommonModule, NgIf],
  template: `
    <div class="comment-container">
      <span (click)="toggleText()" class="comment-text">
        @if (!showFullText()) {
          {{ getTruncatedText(text()) }}
        } @else {
          {{ getTruncatedText(text(), 600) }}
        }
      </span>
    </div>
  `,
  styles: [
    `
      .comment-container {
        display: inline-block;
        max-width: 100%;
      }
      .comment-text {
        user-select: text; /* Allow text selection */
        cursor: pointer;
        white-space: pre-wrap;
      }
    `,
  ],
})
export class TableTasksLatestCommentRendererComponent implements ICellRendererAngularComp {
  text = signal('');
  showFullText = signal(false);

  agInit(params: any): void {
    this.text.set(params.data.last_comment?.trim());
  }

  getTruncatedText(value: string, limit = 80): string {
    return value?.length > limit ? value?.substring(0, limit) + '...' : value;
  }

  refresh(params: any): boolean {
    this.text.set(params.data.last_comment?.trim());
    return true;
  }

  toggleText(): void {
    this.showFullText.set(!this.showFullText());
  }
}
